import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

interface SubLayoutDeleteFormProps {
  values: { name: string }
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  fetching: boolean
  title: string
  submitButtonText: string
  onClickCancel: () => void
}

export const SubLayoutDeleteForm = ({
  values,
  handleSubmit,
  fetching,
  title,
  submitButtonText,
  onClickCancel
}: SubLayoutDeleteFormProps) => (
  <>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Form noValidate onSubmit={handleSubmit}>
      <Modal.Body>
        <p>以下の小組を削除します。よろしいですか？</p>
        <p>小組名称：{values.name}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClickCancel}>
          キャンセル
        </Button>
        <Button type='submit' disabled={fetching}>
          {submitButtonText}{' '}
        </Button>
      </Modal.Footer>
    </Form>
  </>
)
